var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3198.953,
    height: 1462.021,
    viewBox: "0 0 3198.953 1462.021"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Silvy_-_Icon_-_White",
    "data-name": "Silvy - Icon - White",
    d: "M619.053,3116.855c-377.853,41.558-602.5-407.45-617.839-861.2-22.127-654.387,263.963-833.319,386.361-1157.485C590.379,561.03,263.328,378.99,283.752,156.707S530.548-19.235,687.135,98.06c212.142,158.909,539.1,892.219,61.272,1324.212C328.485,1801.9,249.8,2086.334,216.151,2255.653c-52.763,265.46,11.832,674.191,296.577,674.191,201.639,0,256.1-288.311,208.447-501.3-35.923-160.547-80.889-411.125-6.808-577.255,64.678-145.043,165.1-228.077,282.536-200.6,148.076,34.641,211.076,202.277,238.288,367.322C1314.565,2499.506,996.9,3075.3,619.053,3116.855Z",
    transform: "translate(87.018 1462.021) rotate(-94)",
    fill: "#faede4"
  })));
};

export default __webpack_public_path__ + "static/media/silvy_s_header.13564939.svg";
export { SvgComponent as ReactComponent };